// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__24XKF","inner":"Form_inner__OyNWw","range":"Form_range__2ECRl","name":"Form_name__1Btdg","actions":"Form_actions__1_VQP"};